/**
 * Removes socialValues from Localstorage
 */
export const removeSocialValuesLocalStorage = () => {
  localStorage.removeItem('social');
  localStorage.removeItem('social_type');
  localStorage.removeItem('mobile_access_token');
};
